import {useFilterByLicense} from '@/biz/license.jsx'
import MenuButton from '../../MenuButton.jsx'
import useMenuItemAiGenerateWf from '../../menuButtons/useMenuItemAiGenerateWf.jsx'
import useMenuItemAiGenerateWs from '../../menuButtons/useMenuItemAiGenerateWs.jsx'
import useMenuItemAiCodeRci from './useMenuItemAiCodeRci.jsx'
import useMenuItemAiGenerateAtcf from './useMenuItemAiGenerateAtcf.jsx'
import useMenuItemAiGenerateBdlogic from './useMenuItemAiGenerateBdlogic.jsx'
import useMenuItemAiGenerateBfc from './useMenuItemAiGenerateBfc.jsx'
import useMenuItemAiGenerateBr from './useMenuItemAiGenerateBr.jsx'
import useMenuItemAiGenerateCatdt from './useMenuItemAiGenerateCatdt.jsx'
import useMenuItemAiGenerateCatlogic from './useMenuItemAiGenerateCatlogic.jsx'
import useMenuItemAiGenerateCode from './useMenuItemAiGenerateCode.jsx'
import useMenuItemAiGenerateDa from './useMenuItemAiGenerateDa.jsx'
import useMenuItemAiGenerateDes from './useMenuItemAiGenerateDes.jsx'
import useMenuItemAiGenerateDt from './useMenuItemAiGenerateDt.jsx'
import useMenuItemAiGenerateDk from './useMenuItemAiGenerateDk.jsx'
import useMenuItemAiGenerateFa from './useMenuItemAiGenerateFa.jsx'
import useMenuItemAiGenerateFcase from './useMenuItemAiGenerateFcase.jsx'
import useMenuItemAiGenerateImpact from './useMenuItemAiGenerateImpact.jsx'
import useMenuItemAiGenerateQr from './useMenuItemAiGenerateQr.jsx'
import useMenuItemAiGenerateRam from './useMenuItemAiGenerateRam.jsx'
import useMenuItemAiGenerateRole from './useMenuItemAiGenerateRole.jsx'
import useMenuItemAiGenerateScn from './useMenuItemAiGenerateScn.jsx'
import useMenuItemAiGenerateSds from './useMenuItemAiGenerateSds.jsx'
import useMenuItemAiGenerateSummary from './useMenuItemAiGenerateSummary.jsx'
import useMenuItemAiGenerateTest from './useMenuItemAiGenerateTest.jsx'
import useMenuItemAiGenerateTg from './useMenuItemAiGenerateTg.jsx'
import useMenuItemAiGenerateTrd from './useMenuItemAiGenerateTrd.jsx'
//import useMenuItemAiGenerateTs from './useMenuItemAiGenerateTs.jsx'
import useMenuItemAiGenerateUc from './useMenuItemAiGenerateUc.jsx'
import useMenuItemAiGenerateUe from './useMenuItemAiGenerateUe.jsx'
import useMenuItemAiGenerateUi from './useMenuItemAiGenerateUi.jsx'
import useMenuItemAiGenerateUpt from './useMenuItemAiGenerateUpt.jsx'
import useMenuItemAiGenerateUptBdlogic from './useMenuItemAiGenerateUptBdlogic.jsx'
import useMenuItemAiGenerateUtc from './useMenuItemAiGenerateUtc.jsx'
import useMenuItemAiGenerateUv from './useMenuItemAiGenerateUv.jsx'
import useMenuItemAiGenerateUvCode from './useMenuItemAiGenerateUvCode.jsx'
import useMenuItemAiGenerateWebCode from './useMenuItemAiGenerateWebCode.jsx'
import useMenuItemAiReverseDt from './useMenuItemAiReverseDt.jsx'
import useMenuItemAiReverseFp from './useMenuItemAiReverseFp.jsx'
import useMenuItemAiReverseScn from './useMenuItemAiReverseScn.jsx'

export default function MenuButtonAi(props) {
    const filterByLicense = useFilterByLicense()

    const items = [
        useMenuItemAiGenerateTg(),
        useMenuItemAiReverseFp(),
        useMenuItemAiGenerateCatlogic(),
        useMenuItemAiGenerateDes(),
        useMenuItemAiGenerateFcase(),
        useMenuItemAiGenerateUc(),
        useMenuItemAiGenerateTest(),
        useMenuItemAiGenerateUtc(),
        useMenuItemAiCodeRci(),
        useMenuItemAiGenerateDt(),
        useMenuItemAiGenerateBfc(),
        //useMenuItemAiGenerateFa(),
        useMenuItemAiGenerateUe(),
        useMenuItemAiGenerateUv(),
        useMenuItemAiGenerateUvCode(),
        useMenuItemAiGenerateRole(),
        useMenuItemAiGenerateDk(),
        useMenuItemAiGenerateSummary(),
        useMenuItemAiGenerateQr(),
        useMenuItemAiGenerateAtcf(),
        useMenuItemAiGenerateDa(),
        useMenuItemAiGenerateCatdt(),
        useMenuItemAiGenerateTrd(),
        //useMenuItemAiGenerateTs(),
        useMenuItemAiGenerateWs(),
        useMenuItemAiGenerateWf(),
        useMenuItemAiGenerateImpact(),
        useMenuItemAiGenerateUpt(),
    ]

    return filterByLicense('M00040001',
        <MenuButton
            items={items}
            {...props}
        >
            AI助手
        </MenuButton>
    )
}
